const makeTransition = (attribute = 'all', time = 0.5): string =>
  `${attribute} ${time}s ease-in-out`

export default makeTransition
